import { auth } from '../firebase';

// The name shown on the "you" row of the share guide's drawn dialog: the person's own name, so the
// picture looks like their screen. Display name, else the part of their email before the @, else a
// plain "You". Never throws (the guide must open even when sign-in state is odd).
export function ownerNameOf(user) {
  if (!user) return 'You';
  const display = (user.displayName || '').trim();
  if (display) return display.length > 24 ? display.slice(0, 23).trimEnd() + '\u2026' : display;
  const local = String(user.email || '').split('@')[0].replace(/[._+-]+/g, ' ').trim();
  if (!local) return 'You';
  const name = local.replace(/\b\w/g, (c) => c.toUpperCase());
  return name.length > 24 ? name.slice(0, 23).trimEnd() + '\u2026' : name;
}

export default function currentOwnerName() {
  try {
    return ownerNameOf(auth && auth.currentUser);
  } catch (e) {
    return 'You';
  }
}
